import {  SET_TITLE, SET_DESCRIPTION } from "../actions/types";
const initialState = {
    title: '',
    description: ''
};
export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_TITLE:
            return {
                title: payload,
                description: state.description
            };
        case SET_DESCRIPTION:
            return {
                title: state.title,
                description: payload
            };
        default:
            return state;
    }
}